import React from 'react'
import moment from 'moment'
import TriplePointTakeoverBackground from 'components/Common/SiteTakeover/TriplePointTakeover/TriplePointTakeoverBackground'
import Group from 'components/utils/Group'
import TriplePointTakeoverSearchTileBanner from 'components/Common/SiteTakeover/TriplePointTakeover/TriplePointTakeoverSearchTileBanner'
import TriplePointTakeoverSearchBanner from 'components/Common/SiteTakeover/TriplePointTakeover/TriplePointTakeoverSearchBanner'
import TriplePointTakeoverHeroSubtitle from 'components/Common/SiteTakeover/TriplePointTakeover/TriplePointTakeoverHeroSubtitle'
import TriplePointTakeoverLogo from 'components/Common/SiteTakeover/TriplePointTakeover/TriplePointTakeoverLogo'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

export const triplePointCampaignId = 'triple points june 2025'
export const triplePointsTakeoverId = 'societytriplepoints'

const SocietyTriplePointsTakeover: App.SiteTakeover = {
  id: triplePointsTakeoverId,
  startDate: moment('2025-06-20T00:08:00+1100'),
  endDate: moment('2025-07-22T23:59:00+1100'),
  brands: new Set(['luxuryescapes']),
  regions: new Set(['AU']),
  verticals: new Set(['home', 'hotel', 'tours', 'cruise']),
  offerTypes: new Set<App.OfferType>([
    'hotel',
    'tactical_ao_hotel',
    'direct_tour',
    'partner_tour',
    'connection_tour',
    'partner_tour',
    'cruise',
  ]),
  campaignTags: new Set([triplePointCampaignId]),
  palette: 'default',
  backgroundElement: TriplePointTakeoverBackground,
  searchPage: {
    bannerContent: <TriplePointTakeoverSearchBanner />,
    tileBanner: <TriplePointTakeoverSearchTileBanner />,
  },
  landingPage: {
    banner: {
      description: <b>Enjoy triple bonus points on these limited-time special offers.</b>,
      logo: <TriplePointTakeoverLogo size="small" />,
      bannerAction: {
        to: '/triple-points',
        label: 'View offers',
      },
    },
  },
  offerPage: {
    bannerContent: <Group direction="horizontal" gap={12} verticalAlign="center">
      <TriplePointTakeoverLogo size="small" />
      <b>Enjoy triple bonus points on this limited-time special offer.</b>
    </Group>,
  },
  heroCarousel: {
    title: 'Curated escapes you’ll love',
    subtitle: <TriplePointTakeoverHeroSubtitle />,
    logo: <CSSBreakpoint min="tablet"><TriplePointTakeoverLogo size="medium" /></CSSBreakpoint>,
    palette: 'default',
    verticals: ['home'],
    filters: [
      { label: 'Triple points', value: triplePointCampaignId, type: 'campaignTag' },
      { label: 'Dining & Drinks', value: 'Dining & Drinks', type: 'holidayType' },
      { label: 'Family Friendly', value: 'Family Friendly', type: 'holidayType' },
    ],
  },
}

export default SocietyTriplePointsTakeover
